import './MixPopoverAnimate.css';
import { cn } from '../../utils/bem';
import { cnForCssTransition } from '../../utils/cnForCssTransition';
var cnFn = cn('MixPopoverAnimate');
export var cnMixPopoverAnimate = cnFn;
export var cnMixPopoverAnimateForCssTransition = cnForCssTransition(cnFn);
export var animateTimeout = 200;
